import styled from "styled-components";

export const Container = styled.section`
    width: 100%;    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #58626c;
    padding: 0 6rem;
    
    h1 {
        font-family: 'Great Vibes', sans-serif;
        font-size: 3.7rem;
        font-weight: 200;
    }

    h2 {
        max-width: 500px;
        margin: 1rem 0;
        font-family: 'Josefin Slab', sans-serif;
        font-weight: 200;
        font-size: 2rem;
        color: #58626c;
    }

    p {
        margin-top: 2rem;
        max-width: 1100px;
    }

    @media (max-width: 870px) {
        padding: 0 3rem;
    }

    @media (max-width: 770px) {
        padding: 0 1rem;

        h1 {
            text-align: center;
        }
    }

    @media (max-width: 500px) {
        h1 {
            font-size: 3rem;
        }
        h2 {
            font-size: 1.7rem;
        }
        p {
            font-size: 12px;
        }
    }

    
    @media (max-width: 320px) {
        h1 {
            font-size: 2rem;
        }
    }

`

export const Content = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;

    a.cardLista {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
        padding: 20px;
        margin: 40px 0;
        
        border-radius: 10px;
        box-shadow: 0 0 25px -14px rgb(0 0 0 / 75%);

        transform: scale(0.9);
        transition: all ease 0.2s;

        &:hover {
            transform: scale(1);
            box-shadow: 0 0 25px 2px rgb(0 0 0 / 75%);
        }
    }
    
    div.cardLista {  
        display: flex; 
        flex-direction: column;
        justify-content: center;
        align-items: center;     
        button {
            padding: 7px 20px;
            border: 1px solid #ff69b4;
            border-radius: 5px;
            background: #e2799b;
            color: #fff;
            font-size: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 30px auto 20px;
            transition: 0.2s;
            text-decoration: none;

            &:hover {
                background: #dd648b;
            }
        }

        img {
            width: 100%;
            height: 350px;
        }
    } 
    
    @media (max-width: 500px) {
        display: flex;
        flex-direction: column;

        a.cardLista {
            width: 100%;
            margin: 0;
            img {
                width: 100%;
                height: 100px;
            }
        }

    }

`